<template>
  <div class="content-container">
    <filters-archival-measurements />

    <div class="content-wrap">

      <ArchivalMeasurements
          :step="archival.step"
          @nextStep="nextStep"
          @previousStep="previousStep"
          @clear="clear"
      />
    </div>
  </div>
</template>

<script>
import { onMounted } from "vue";
import { useRoute } from "vue-router";
import ArchivalMeasurements from "../components/ArchivalMeasurements.vue";
import FiltersArchivalMeasurements from "../components/FiltersArchivalMeasurements.vue";
import { useArchivalStore } from "@/stores/archival";

export default {
  name: "ArchivalView",
  components: {
    ArchivalMeasurements,
    FiltersArchivalMeasurements,
  },
  setup() {
    const archival = useArchivalStore();
    const route = useRoute();

    // onMounted(() => {
    //   if (!route.meta.result) {
    //     archival.clear();
    //   }
    // });

    onMounted(() => {
      if (route.meta.result === true) return;
    });

    function nextStep() {
      archival.nextStep();
    }

    function previousStep() {
      archival.previousStep();
    }

    function clear() {
      archival.clear();
    }

    return {
      archival,
      nextStep,
      previousStep,
      clear,
    };
  },
};
</script>

<style scoped>
/* Delikatne, jasne tło dla widoku */
.content-container {
  background-color: var(--surface-secondary);
}
</style>
